import { appRoutesUrls } from "constants/appRoutesUrls";
import React, { useState } from "react";
import { Button, InputGroup } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import Form from 'react-bootstrap/Form';
import { useNavigate } from "react-router-dom";
import { allowNumber } from "utils/inputValidator";

const InvoiceSearch = () => {
    const navigate = useNavigate();
    const [invoiceId, setInvoiceId] = useState('');

    const handleChange = (e) => {
        if (!allowNumber(e.target.value)) { return; }
        setInvoiceId(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setInvoiceId('');
        if (invoiceId > 0) {
            navigate(appRoutesUrls.invoicedetails(invoiceId));
        }
    }

    return (
        <Form onSubmit={handleSubmit}>
            <InputGroup size="md" className="ms-2" style={{ maxWidth: '200px', height: '38px' }}>
                <Form.Control
                    size="md"
                    placeholder="INV ID"
                    maxLength={10}
                    value={invoiceId}
                    onChange={handleChange} />
                <Button                    
                    type="submit"
                    variant="info"
                    style={{ borderColor: 'hsl(0, 0%, 80%)' }}>
                    <Search size={18} />
                </Button>
            </InputGroup>
        </Form>
    )
}

export default InvoiceSearch;